export const APP_ROUTING_NAMES = {
    ANSOKAN_NO_LOGIN: 'nologin/ansokan',
    NOT_FOUND: 'not-found',
    START: 'start',
    SUPPLEMENT: 'komplettering',
    LOGGED_IN: 'loggedin',
};
